import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from './ui/button';

const OrderCancelled = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-4">
      <div className="max-w-2xl w-full bg-white rounded-3xl p-12 text-center shadow-2xl">
        <div className="w-24 h-24 bg-gray-500 rounded-full flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-16 h-16 text-white" />
        </div>
        <h1 className="text-4xl font-bold text-black mb-4">Order Cancelled</h1>
        <p className="text-xl text-gray-600 mb-8">
          Your order has been cancelled. No charges have been made to your card.
        </p>
        <div className="flex gap-4 justify-center">
          <Button
            onClick={() => navigate('/')}
            className="bg-black text-white hover:bg-gray-800 px-8 py-6 text-lg"
          >
            Back to Home
          </Button>
          <Button
            onClick={() => {
              navigate('/');
              setTimeout(() => {
                document.getElementById('menu')?.scrollIntoView({ behavior: 'smooth' });
              }, 100);
            }}
            variant="outline"
            className="border-2 border-black text-black hover:bg-gray-100 px-8 py-6 text-lg"
          >
            Continue Shopping
          </Button>
        </div>
      </div>
    </div>
  );
};

export default OrderCancelled;
